








import Vue from 'vue';
import { Form } from 'element-ui';

export default Vue.extend({
	name: 'DmsForm',
	extends: Form,
});

